import * as React from "react";
import Box from "@mui/material/Box";
import ReportAndResourcesHeader from "../ReportAndResourcesHeader";
import ViewClientSpecificReport from "./ViewClientSpecificReport";


const ClientSpecificReportHome = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <ViewClientSpecificReport />
    </Box>
  );
};

export default ClientSpecificReportHome;
